import {ThirdPartyTokenChannel} from "@irati/types"

export default ThirdPartyTokenChannel.ThirdPartyChannelWeb
